import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const BlackButton = styled(Button)(({ theme }) => ({
    fontWeight: 'bold',
    height: 'fit-content',
    borderRadius: 10,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '40%',
    border: '2px solid',
    borderColor: '#16191e',
    color: '#FBFCFA',
    backgroundColor: '#16191e',
    "&&:hover": {
        border: '2px solid',
        backgroundColor: "#FBFCFA",
        borderColor: "#16191e",
        color: "#16191e",
        fontWeight: 'bold',
    },
    "&&:focus": {
        border: '2px solid',
        backgroundColor: "#FBFCFA",
        borderColor: "#16191e",
        color: "#16191e",
        fontWeight: 'bold',
    },
}));

export const OutlinedWhiteButton = styled(Button)(({ theme }) => ({
    fontWeight: 'bold',
    borderRadius: 10,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '40%',
    height: 'fit-content',
    color: '#FBFCFA',
    backgroundColor: '#ab142c',
    border: '2px solid',
    borderColor: '#ab142c',
    "&&:hover": {
        color: '#ab142c',
        border: '2px solid',
        borderColor: '#ab142c',
        backgroundColor: '#FBFCFA',
        fontWeight: 'bold',
    },
    "&&:focus": {
        color: '#ab142c',
        border: '2px solid',
        borderColor: '#ab142c',
        backgroundColor: '#FBFCFA',
        fontWeight: 'bold',
    }
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
    fontWeight: 'bold',
    margin: theme.spacing(2),  // 'my' en camelCase est 'marginY' pour MUI
    paddingTop: theme.spacing(1.5), // Manually setting padding-top
    paddingBottom: theme.spacing(1.5), // Manually setting padding-bottom
    paddingLeft: 25,
    paddingRight: 25,
    color: '#16191e',
    fontWeight: 'bold',
    fontSize: '12px',
    borderRadius: 0,
    borderColor: '#16191e',
    border: '1px solid',
    height: 'fit-content',
    backgroundColor: 'transparent', // Fond transparent par défaut
    "&&:hover": {
        color: '#16191e',
        borderColor: '#16191e',
        backgroundColor: '#eeeeee', // Fond grisé au survol
        fontWeight: 'bold',
    },
    "&&:focus": {
        color: '#16191e',
        borderColor: '#16191e',
        backgroundColor: '#eeeeee', // Fond grisé au focus aussi
        fontWeight: 'bold',
    }
}));


export const OutlinedBlackButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(2),  // 'my' en camelCase est 'marginY' pour MUI
    paddingTop: theme.spacing(1.5), // Manually setting padding-top
    paddingBottom: theme.spacing(1.5), // Manually setting padding-bottom
    paddingLeft: 25,
    paddingRight: 25,
    height: 'fit-content',
    fontWeight: 'bold',
    fontSize:'12px',
    borderRadius: 0,
    color: '#16191e',
    backgroundColor: 'transparent',
    borderColor: '#16191e',
    "&&:hover": {
        color: '#ab142c',
        borderColor: '#ab142c',
        backgroundColor: '#FBFCFA',
        fontWeight: 'bold',
    },
    "&&:focus": {
        color: '#ab142c',
        borderColor: '#FBFCFA',
        fontWeight: 'bold',
    }
}));

export const OutlinedRedButton = styled(Button)(({ theme }) => ({
    margin: 5,
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 25,
    paddingRight: 25,
    height: 'fit-content',
    fontSize: '12px',
    borderRadius: 0,
    color: '#9d0208',
    backgroundColor: 'transparent',
    borderColor: '#9d0208',
    "&&:hover": {
        color: '#9d0208',
        borderColor: '#9d0208',
    },
    "&&:focus": {
        color: '#898b96',
        borderColor: '#898b96',
    }
}));


/* "&&:hover": {
    backgroundColor: "#FBFCFA",
    borderColor: "#ab142c",
    color: "#ab142c",
    fontWeight: 'bold',
},
"&&:focus": {
    backgroundColor: "#FBFCFA",
    borderColor: "#ab142c",
    color: "#ab142c",
} */